const a = (p, e) => e ? "".concat(p).concat(e.replace("--spacing", "")) : "";
export { a as spacingReplace };